<template>
  <div class="flex w-full h-screen rounded-lg shadow-lg">
    <!-- Left Image & Text -->
    <div
        :style="{ backgroundImage: `url(${require('@/assets/img/Malhadinha-Nova-3.webp')})` }"
        class="w-2/4 flex flex-col flex-[1.2] bg-cover bg-center bg-no-repeat relative text-primary px-10"
    >
      <div class="mt-20 text-center">
        <h2 class="text-4xl font-bold mb-2">A new home starts with</h2>
        <h1 class="text-6xl font-bold">Bison Bank</h1>
      </div>
    </div>

    <!-- Right Login Form -->
    <div class="w-2/4 flex flex-col flex-1 justify-center bg-white px-12 text-[#4D2F00] relative">
      <!-- Logo -->
      <div class="flex items-center justify-center mb-10">
        <img
            alt="Bison Mobile Logo"
            class="w-20 h-20 mr-3"
            src="@/assets/img/Bison-bank-logo.png"
        />
        <span class="font-semibold text-3xl text-gray-500">Bison Mobile</span>
      </div>

      <!-- Login Form -->
      <form v-if="!showOtpBox" class="flex flex-col" @submit.prevent="handleSubmit">
        <label class="mb-1 text-sm" for="user">Email</label>
        <input
            v-model="user"
            class="w-full px-4 py-3 mb-5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="Email"
            type="email"
            id="user"
        />

        <label class="mb-1 text-sm" for="password">Password</label>
        <input
            v-model="currentPassword"
            :type="showCurrentPassword ? 'text' : 'password'"
            placeholder="Password"
            class="w-full px-4 py-3 border border-gray-300 rounded-md mb-5 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <button
            @click.prevent="showCurrentPassword = !showCurrentPassword"
            type="button"
            class="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
        >
          Toggle
        </button>

        <button
            class="bg-primary text-white font-semibold py-3 rounded-md transition-colors"
            type="submit"
        >
          LOGIN
        </button>
      </form>

      <!-- OTP Form -->
      <form v-if="showOtpBox" class="flex flex-col" @submit.prevent="handleOtpSubmit">
        <label class="mb-1 text-sm">Enter OTP</label>
        <input
            v-model="otp"
            type="text"
            maxlength="6"
            class="w-full px-4 py-3 border border-gray-300 rounded-md mb-5 focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="6-digit code"
        />
        <button
            class="bg-primary text-white font-semibold py-3 rounded-md transition-colors"
            type="submit"
        >
          VERIFY OTP
        </button>
      </form>

      <!-- Footer -->
      <div class="flex flex-col items-center mt-10 text-sm text-[#4D2F00]">
        <component :is="LockKeyhole"/>
        Always use your Homebanking with safety
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue"
import { LockKeyhole } from 'lucide-vue-next'
import api from '@/services/api'

const user = ref("")
const currentPassword = ref("")
const showCurrentPassword = ref(false)

const otp = ref("")
const showOtpBox = ref(false)
const userId = ref(null)   // ذخیره user_id برگشتی از login مرحله اول

import { useRouter } from 'vue-router'

const router = useRouter()


onMounted(() => {
  const token = localStorage.getItem('token')
  if (token) {
    router.push('/')
  }
})

async function handleSubmit() {
  try {
    const res = await api.post('/login', {
      email: user.value,
      password: currentPassword.value,
    })

    alert("OTP sent to your phone")
    showOtpBox.value = true
    userId.value = res.data.user_id

  } catch (err) {
    console.error("Login error:", err.response?.data || err)
    alert("Login failed: " + err.response?.data?.message)
  }
}

async function handleOtpSubmit() {
  try {
    const res = await api.post('/verify-otp', {
      user_id: userId.value,
      otp: otp.value
    })
    localStorage.setItem('token', res.data.token)
    localStorage.setItem('user', JSON.stringify(res.data.user))
    localStorage.setItem('utc', JSON.stringify(res.data.utc_time))

    alert("Login successful! Welcome " + res.data.user.name)
    router.push('/')
  } catch (err) {
    console.error("OTP verification error:", err.response?.data || err)
    alert("OTP verification failed: " + err.response?.data?.message)
  }
}
</script>
